import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import { AdminAuthProvider } from './context/AdminAuthContext';
import App from './App';
import { BASE_PATH } from './config/constants';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AdminAuthProvider>
      <BrowserRouter basename={BASE_PATH}>
        <App />
      </BrowserRouter>
    </AdminAuthProvider>
  </React.StrictMode>
);
